export const FR = {

index:{
    title_general: "Simulateur de plongée",
que_hace_txt: "Ce qu’il fait?",
objetivo: "L'objectif n'est pas de simuler la plongée, c'est d'améliorer le vrai plongeur.",
modelos_txt_1: "Modèles",
instrumentos_txt: "Instruments",
seguridad_txt: "Sécurité",

que_se_pierde: "Qu'est-ce qu'on perd en enseignant la plongée sans simulation ?",
teoria_de_perdida: `

        <span style="color:#dfbb73;font-size: 20px;">"La théorie enseigne quoi faire. La simulation enseigne pourquoi le faire"</span>

        <br><br>Sans simulation, de nombreux concepts restent abstraits. Les élèves mémorisent les limites, les procédures et les tables, mais ont du mal à visualiser comment leurs décisions affectent réellement l'absorption des gaz, la décompression, l'exposition à l'oxygène et la sécurité de la plongée.
        <br><br>La simulation transforme des processus invisibles en expériences visuelles et interactives. Elle permet d'expérimenter des scénarios, d'analyser les conséquences et de comprendre comment de petits changements de profondeur, de temps ou de vitesse de remontée peuvent modifier tout un profil de plongée.
        <br><br>Pour les moniteurs, cela signifie passer de l'explication de concepts à la démonstration de leur fonctionnement en temps réel.
        <br><strong>Parce que l'objectif n'est pas que l'élève se souvienne d'une règle. C'est qu'il comprenne les conséquences de ses décisions avant d'entrer dans l'eau.</strong>`,



faq_txt: "FAQ",
login_txt: "Connexion",

experiencia_interactiva: "Simulateur de plongée | Entraînement à sec",

que_hace_2: "Divantys vous aide à comprendre la plongée avant d'entrer dans l'eau. Réduisant les risques, accélérant l'apprentissage et améliorant les décisions réelles sous pression.",



visualiza: "Maîtrisez la théorie de la plongée. <strong>Apprenez à gérer et optimiser vos plongées</strong> avant de toucher l’eau",
que_hace_4: `
                <strong>La plongée est coûteuse ; apprendre ne doit pas l’être.</strong><br>
                Entraînez-vous sur le simulateur, pas pendant une plongée que vous payez.<br>
                Entraînez-vous à sec, développez votre expérience et profitez pleinement de chaque minute de votre aventure sous-marine.`,


        all_levels: "Pour les plongeurs débutants et étudiants jusqu’aux plongeurs avancés et instructeurs", 
safety_gestion: "Gérer et effectuer les paliers de sécurité",
aire_profundidad: "Prolongez vos plongées en gérant la profondeur",
gestion_deco: "Gérer et effectuer vos paliers de décompression",
ppo2_gestion: "Gérer et visualiser la PPO2 en fonction de la profondeur",

openModalBtn: "Voir le résumé",


ilustra: `
Le simulateur t'apprend à agir correctement face aux erreurs,
  en te montrant l'avenir de tes décisions avant que tu ne te jettes à l'eau.
`,
preguntas_estrategicas_aprendizaje: `
La question vraiment importante est donc :<br>
  <ul>
    <li>Que se passerait-il si je prenais une décision différente ?</li>
    <li>Que se passe-t-il si je reste cinq minutes de plus au fond ?</li>
    <li>Que se passe-t-il si je remonte trop vite ?</li>
    <li>Comment mes tissus changent-ils si j'utilise un autre mélange de gaz ?</li>
    <li>Comment un palier plus profond ou plus long affecte-t-il mon profil de décompression ?</li>
  </ul>
La simulation permet de répondre à ces questions de manière immédiate, visuelle et sûre.`,

relacion_pp: "Anticiper l'erreur est la meilleure progression d'un plongeur",
ndl: "Limites sans décompression (NDL)",
absorcion: "Absorption d’azote (tissus)",
exposicion: "Exposition à l’oxygène (PPO₂ / SNC)",
habitos_asenso: "Habitudes de remontée plus sûres",
consumo_aire: "Consommation d’air et réserve",
buceo_recreativo: "Plongée récréative",
nitrox_compatible: "Compatible Nitrox",
hud: "HUD à l’écran",
mobil_desktop: "Mobile + Desktop",
startCta: "Entrer dans le simulateur",
que_incluye: "Voir ce qui est inclus",
tiempo: "Conseil : vous pouvez accélérer le temps pour observer plus rapidement l’évolution des indicateurs (par exemple 2×, 5× ou 10×).",
que_hace_3: "Ce que fait ce simulateur",
inmersion_virtual: "Divantys Dive Simulator est une plateforme interactive de simulation et d'apprentissage de la plongée qui permet de visualiser en temps réel les processus physiques et physiologiques qui se produisent lors d'une plongée. Son objectif est de transformer des concepts complexes de la théorie de la plongée, de la décompression et de la physiologie humaine en une expérience visuelle facile à comprendre pour les plongeurs, étudiants, instructeurs et professionnels du secteur. Divantys fonctionne comme un laboratoire virtuel où vous pouvez explorer comment le corps humain réagit à différents profils de plongée, mélanges de gaz, profondeurs et temps d'exposition.",
experiencia_3d: "Expérience 3D contrôlable",
movimiento_cacara: "Mouvement et caméra avec des contrôles adaptés au mobile, à la tablette et au PC.",
joistick_movimiento: "Joystick de déplacement",
joistick_rotacion: "Joystick de regard/rotation",
neutral_flotabilidad: "Zone neutre pour la stabilité",
indicadores_hud: "Indicateurs HUD",
instrumentos_visuales: "Instruments visuels à l’écran pour une compréhension immédiate.",
tanque: "Bouteille : bar / PSI / pourcentage",
barra_nitrogeno: "Barre d’azote (éducative)",
ndl_estado: "NDL et état de remontée",
reporte: "Rapport complet",
resumen: "Résumé de la plongée pour apprentissage et analyse.",
profundidad_maxima: "Profondeur maximale",
tiempo_total: "Temps total",
ndl_total: "NDL total et restant",
ceiling: "Ceiling (profondeur minimale sûre)",
modelos_txt: "Modèles et concepts représentés",
simulador_implementa: "Le simulateur implémente des modèles physiologiques et des règles pédagogiques courantes en plongée récréative : absorption et libération de l’azote par les tissus, limites sans décompression et exposition à l’oxygène.",
modelo_tejidos: "Modèle de tissus (16 compartiments)",
simulador_carge_nitrogeno: "Simule la charge d’azote dans différents tissus à des vitesses variables, permettant d’estimer la saturation, le « ceiling » et le comportement lors de plongées répétitives.",
expoosicion_o2: "Exposition à l’oxygène (PPO₂ / SNC)",
calculo_po2: "Calcule la PPO₂ en fonction de la profondeur et de la fraction d’oxygène (FO₂), et accumule l’exposition SNC selon un modèle de limites basé sur la PPO₂. Inclut des niveaux d’alerte (OK / WARNING / DANGER).",
ndl2: "NDL (Limite sans décompression)",
caluclo_ndl: "Calcule une NDL « récréative » basée sur la profondeur et le temps, avec prise en charge du Nitrox (EAD).",
ndl_total_permitido: "NDL total autorisé",
ndl_restante: "NDL restant selon le profil",
interpretacion_riesgos: "Interprétation pédagogique du risque",
ceiling_asecenso: "Ceiling et remontée",
estimacion_profundidad_ceiling: "Estime une profondeur minimale sûre (ceiling) et évalue si la remontée peut être effectuée sans paliers.",
ceiling_metros: "Ceiling en mètres",
deteccion_parada: "Détection de « stop requis »",
recomendacion_parada: "Recommandation de palier de sécurité",
inmersiones_repetitivas: "Plongées répétitives",
carga_residual: "Maintient la charge résiduelle entre les plongées et simule les intervalles en surface.",
tejidos_conservan: "Les tissus se conservent entre les plongées",
intervalo_superficie: "L’intervalle en surface réduit la charge",
aprendizaje_acumulacion: "Apprentissage de l’accumulation résiduelle",
instrumentos_visualizacion_hud: "Instruments et visualisation (HUD)",
facilitar_comprension: "Pour faciliter la compréhension, le simulateur affiche des instruments visuels à l’écran pendant la plongée. Son objectif est que l’utilisateur « voie » comment les concepts évoluent en fonction de son comportement.",
tanque_aire: "Bouteille d’air (AL80)",
simula_consumo_sac: "Simule la consommation selon le SAC, la pression ambiante et le temps simulé.",
presion_bar_psi: "Pression en bar et PSI",
gas_restante: "Pourcentage restant",
alerta_reserva: "Alerte de réserve (ex. 35 bar)",
sin_aire: "État « sans air » (out of air)",
barra_nitrogeno_2: "Barre d’azote",
visualizacion_educativa: "Visualisation pédagogique de l’augmentation/diminution de la charge.",
suavisado_visual: "Lissage visuel (charge lente / décharge normale)",
colores_nivel: "Couleurs par niveau (vert→rouge)",
enfoque_didactico: "Approche pédagogique, facile à interpréter",
ndk_y_estado_ascenso: "NDL et état de la remontée",
indicadores_limites_descompresion: "Indicateurs pour comprendre les limites sans décompression et les habitudes de remontée.",
ndl_restante_2: "NDL restant",
recomendacion_parada_2: "Recommandation de palier de sécurité",
ceiling_si_aplica: "Ceiling (si applicable)",
escala_tiempo_safety_stop: "Échelle de temps (1×, 2×, 5×, 10×)",
acelerar_tiempo: "Vous pouvez accélérer la simulation pour observer plus rapidement comment les valeurs changent. Cette fonction est utile pour l’apprentissage : elle montre les tendances des indicateurs sans avoir à attendre de longues périodes.",
safety_stop_title: "Palier de sécurité (plongée récréative)",
safety_stop_resumen: "Ce module simule le palier de sécurité à 5 mètres en plongée récréative. Sa logique est basée sur un contrôle en temps réel mis à l’échelle, une tolérance de profondeur et la détection des interruptions ou redescendes pour valider ou invalider le palier.",
deteccion_recomendacion: "Recommandation de palier",
safety_recommendation_meta: "Le palier est recommandé automatiquement selon le profil de plongée.",
profundidad_maxima_safety_stop: "Activé si la profondeur maximale dépasse 10 m",
exclusion_descompresion: "Désactivé en cas de décompression active ou requise",
estado_recomendado: "État : recommended → active le palier de sécurité",
callback_recomendacion: "Callback optionnel de notification à l’utilisateur",
logica_ejecucion: "Logique d’exécution",
safety_execution_meta: "Le système contrôle le temps dans la zone des 5 mètres avec tolérance et mise à l’échelle du temps.",
zona_parada: "Zone de palier : 5 m ± 2 m",
zona_pausa: "Zone de pause : 5 m - 3 m (pas de progression)",
acumulacion_tiempo_safety_stop: "Accumulation du temps en secondes simulées",
escala_tiempo: "Mise à l’échelle par la vitesse de simulation (GET_TIME_SCALE)",
completado_3min: "Complété après 180 secondes effectives",
pausa_reanuda: "Pause automatique en quittant la zone",
interrupciones_redescenso: "Interruptions et redescente",
safety_interrupt_meta: "Détecte si le plongeur quitte le palier ou redescend après l’avoir complété.",
rompe_parada: "Sortir de la zone invalide la progression",
cancelacion: "L’état « cancelled » déclenche la réinitialisation du suivi",
interrupted_flag: "Marque une interruption si la logique est rompue",
redescenso_invalida: "Redescente > 6 m relance la recommandation",
ventana_tiempo: "Fenêtre de 30 s pour invalidation après complétion",
safety_stop_tiempo: "Contrôle du temps au palier",
safety_stop_explicacion: "Le temps est calculé en temps réel simulé, en s’accumulant uniquement lorsque le plongeur reste dans la plage correcte. S’il quitte la zone, le compteur se met en pause. S’il complète les 3 minutes effectives, le palier est marqué comme terminé. Cependant, une redescente ultérieure peut l’invalider sous certaines conditions physiologiques.",
nitrogen_load_title: "Barre de charge d’azote (UI éducative)",
nitrogen_load_resumen: "Ce module visualise en temps réel la charge d’azote dans les tissus rapides du plongeur. Son objectif est pédagogique : montrer comment la saturation relative évolue pendant la plongée à l’aide d’une barre de progression lissée et codée par couleurs.",
visualizacion_n2: "Visualisation de la charge en N₂",
n2_visual_meta: "Représente de manière simplifiée le niveau de saturation en azote dans les tissus rapides.",


ppo2_vizualiza:"PPO₂ et SNC",
    ppo2_visualiza_desc:"Visualisez la toxicité de l'oxygène à l'aide du PPO₂ et du SNC accumulé. L'état est représenté par des niveaux de risque physiologique.",
    ppo2_visualiza_p1:"Couleurs illustratives du niveau de toxicité",
    ppo2_visualiza_p2:"SNC accumulé",

    profundimetro:"Profondeur en temps réel",
    profundimetro_educativa:"Surveillance continue de la profondeur pour mieux comprendre l'évolution du profil de plongée.",
    profundimetro_visualiza_p1:"Mise à jour dynamique de la profondeur pendant toute la plongée.",
    profundimetro_visualiza_p2:"Lissage visuel simulant le comportement des instruments réels.",






    tejidos_rapidos: "Basé sur les tissus rapides du modèle physiologique",
valor_porcentual: "Valeur exprimée en pourcentage (0–130%)",
suavizado_visual_2: "Lissage visuel pour éviter les sauts brusques",
actualizacion_tiempo_real: "Mise à jour en temps réel",
codigo_colores_n2: "Code couleur",
n2_colors_meta: "La barre change de couleur selon le niveau de charge afin de faciliter une interprétation rapide.",
verde_seguro: "Vert : charge faible et stable (< 60%)",
amarillo_atencion: "Jaune : zone d’attention (60%–85%)",
naranja_alto: "Orange : charge élevée (85%–100%)",
rojo_riesgo: "Rouge : sursaturation potentielle (> 100%)",
logica_suavizado: "Logique de lissage et de stabilité",
n2_smoothing_meta: "La valeur visuelle ne change pas instantanément, mais se rapproche progressivement de la valeur réelle.",
interpolacion_visual: "Interpolation progressive (ease-in / ease-out)",
respuesta_diferencial: "Réponse plus lente à l’augmentation qu’à la diminution",
prevencion_flicker: "Prévention du scintillement visuel",
clamp_visual: "Limitation des valeurs entre 0% et 130%",
n2_bar_texto_secundario: "Informations secondaires (GF / état physiologique)",
n2_bar_explicacion: "La barre peut inclure du texte supplémentaire (comme le Gradient Factor ou l’état du modèle physiologique). Cela permet de corréler visuellement la saturation en azote avec l’état de décompression, offrant une représentation plus intuitive du risque accumulé.",
air_consumption_title: "Consommation d’air (AL80 multi-bouteilles)",
air_consumption_resumen: "Ce module simule la consommation réelle de gaz en temps dynamique en utilisant le SAC (Surface Air Consumption), la pression ambiante et l’échelle de temps. Il prend en charge des configurations à une ou plusieurs bouteilles et calcule l’épuisement progressif du système complet.",
modelo_consumo: "Modèle de consommation",
air_model_meta: "La consommation est basée sur le SAC du plongeur ajusté par la pression ambiante et le temps simulé.",
sac_rate: "SAC configurable par l’utilisateur",
presion_ambiente: "Pression ambiante = 1 + profondeur/10",
escala_tiempo_aire: "Échelonné par GET_TIME_SCALE()",
consumo_proporcional: "Consommation proportionnelle par bouteille",
sistema_multitanque: "Système multi-bouteilles",
air_tanks_meta: "Le système répartit la consommation entre toutes les bouteilles actives de l’équipement.",
al80_base: "Bouteille de base AL80 (2265 L)",
multi_tank_support: "Prise en charge de plusieurs bouteilles",
division_consumo: "Consommation répartie entre les bouteilles actives",
estado_out_of_air: "État global OUT OF AIR",
visualizacion_hud_aire: "Affichage HUD",
air_hud_meta: "Chaque bouteille est représentée par une barre verticale de niveau et une lecture de pression en bar et PSI.",
nivel_visual_barra: "Niveau visuel en pourcentage de volume",
bar_psi_conversion: "Conversion bar / PSI en temps réel",
colores_reserva: "Couleur selon la réserve (vert → orange → rouge)",
alerta_reserva_aire: "Alerte en dessous de 35 bar",
air_system_tank_title: "État du système d’air",
air_system_explainer: "Le système calcule le volume total restant en additionnant toutes les bouteilles actives. La consommation est mise à jour à chaque frame simulée et permet de détecter le point de réserve ou la condition critique de « sans air ». Le modèle reflète à la fois la consommation individuelle et globale.",
oxygen_toxicity_title: "Toxicité de l’oxygène (NOAA CNS)",
oxygen_toxicity_resumen: "Ce module évalue le risque de toxicité de l’oxygène à l’aide de la PPO₂ et du CNS accumulé. L’état est représenté par des niveaux de risque physiologique similaires à ceux d’un ordinateur de plongée.",
ppo2_model: "Pression partielle d’oxygène (PPO₂)",
ppo2_meta: "Détermine le risque immédiat de toxicité aiguë.",
formula_ppo2: "PPO₂ = FO₂ × pression ambiante",
limite_ppo2: "Limite opérationnelle : 1,4 bar",
limite_critico: "Critique : ≥ 1,6 bar",
cns_model: "CNS (Système nerveux central)",
cns_meta: "Accumulation progressive de l’exposition à l’oxygène selon le modèle NOAA.",
noaa_model: "Modèle d’exposition NOAA",
acumulacion_cns: "Augmentation progressive au fil du temps",
limite_cns: "100% = limite recommandée",
estado_oxigeno: "État de toxicité de l’oxygène",
oxy_state_meta: "Évaluation combinée de la PPO₂ et du CNS en temps réel.",
stateOK: "OK",
stateWARN: "AVERTISSEMENT",
stateDANGER: "DANGER",
state_ok: "OK : exposition dans les limites sûres",
state_warning: "AVERTISSEMENT : zone de prudence",
state_danger: "DANGER : risque de toxicité aiguë",
oxygen_system_title: "Modèle de risque d’oxygène",
oxygen_system_explainer: "Le système combine la toxicité aiguë (PPO₂) et la toxicité cumulative (CNS). L’état affiché reflète le niveau de risque dominant à chaque moment de la plongée, similaire à un ordinateur de plongée technique réel.",
logica_deco_engine: "Logique du moteur de décompression (Bühlmann + GF)",
resumen_logica_deco: "Ce module calcule en temps réel le plan de décompression du plongeur en simulant la saturation des tissus en azote, en générant des paliers obligatoires et en ajustant le profil de remontée selon l’état physiologique et le gradient de sécurité (GF). Il maintient également un historique persistant afin de ne pas perdre la progression entre les régénérations du plan.",
generacion_plan: "Génération du plan de décompression",
plan_buhlmann: "Le système construit un profil de paliers basé sur le modèle Bühlmann avec Gradient Factors.",
calculo_ceiling: "Calcul du plafond avec ligne GF (limite de remontée sûre)",
redondeo_paradas: "Arrondi aux paliers standard (STOP_STEP_M)",
simulacion_exposicion: "Simulation de la charge des tissus par palier",
condicion_fin: "Se termine lorsque le plafond descend sous 3 m (STOP_REQUIRED_M)",
modo_preview: "Mode aperçu sans affecter l’historique réel",
historial_persistencia: "Historique et persistance des paliers",
deco_history: "Le système enregistre la progression de chaque palier afin d’éviter toute perte d’état lors des régénérations.",
decohistory_array: "decoHistory stocke la progression par profondeur",
hydrate_paradas: "Hydratation des paliers depuis l’historique",
preserva_progreso: "Préserve le temps effectué (timePerformedSec)",
evita_reset: "Évite la réinitialisation des paliers déjà commencés",
merge_plan: "Fusion entre le nouveau plan et l’état précédent",
update_deco_logic: "Le moteur recalcule en continu l’état de décompression selon la profondeur, le temps simulé et les tissus.",
control_parada_actual: "Contrôle du palier actuel avec tolérance de profondeur",
bloqueo_orden: "Verrouillage de l’ordre (impossible de sauter des paliers précédents)",
regeneracion_dinamica: "Régénération si le profil s’améliore ou se dégrade",
acumulacion_tiempo: "Accumulation du temps par dtSimSec",
auto_complete: "Complétion automatique à 95%",
tts_dinamico: "Calcul dynamique du TTS (remontée + paliers)",
tts_resumen: "Temps total jusqu’à la surface (TTS)",
tts_explicacion: "Le TTS est calculé en combinant le temps de remontée segment par segment (selon la vitesse de remontée) avec le temps restant dans les paliers de décompression actifs. Le résultat s’ajuste en continu en fonction de l’état réel des tissus et du plan en cours.",
uso_responsable: "Utilisation responsable et avis important",
herramienta_educativa: "Ce projet est un outil éducatif et illustratif. La plongée réelle nécessite une formation, un équipement certifié et une supervision professionnelle.",
importante: "Important",
que_hace_3_txt: "Ce simulateur <strong>n’est pas</strong> un cours de plongée, <strong>ne remplace pas</strong> une formation formelle et <strong>n’est pas</strong> un ordinateur de plongée ni un outil opérationnel de planification. Il <strong>ne doit pas</strong> être utilisé pour planifier des plongées réelles ni pour la prise de décision. Tout ce qui est présenté est <strong>uniquement à des fins illustratives</strong>, en utilisant des concepts et algorithmes appliqués uniquement pour la simulation et la visualisation. L’utilisation du simulateur relève de la responsabilité de l’utilisateur.",
ackCheck: "",
entiendo_educativo: "Je comprends que ce simulateur est uniquement éducatif, ne remplace pas une formation certifiée ni un ordinateur de plongée, et ne doit pas être utilisé pour planifier ou réaliser des plongées réelles.",
enterBtn: "Entrer dans le simulateur",
learnMoreBtn: "Voir les détails du système",
faq_txt_2: "Questions fréquentes",
que_es: "Est-ce un planificateur de plongée ?",
es_aprendizaje_visual: "Non. C’est un outil d’apprentissage visuel. Il ne doit pas être utilisé pour planifier des plongées réelles.",
que_gases_contempla: "Quels gaz sont pris en compte ?",
cuales_gases: "L’air et le Nitrox sont pris en compte via la fraction d’oxygène (FO₂), affectant le NDL, l’azote et le PPO₂/CNS.",
mobil_funciona: "Fonctionne-t-il sur mobile ?",
si_funciona_mobil: "Oui. Les contrôles s’adaptent avec des joysticks et la gestion des événements de pointeur (pointer events).",
team_txt_2: "Équipe",

se_descarga: "Faut-il le télécharger ?",
no_se_descarga: "Nous utilisons la technologie <strong>3D WebGL</strong> afin que vous n'ayez pas besoin de le télécharger depuis une boutique d'applications et puissiez en profiter librement et sans limite directement dans votre navigateur.",


gonzalo_desc: "Instructeur de plongée | Technicien logiciel",
title_footer: "Simulateur de plongée",
footer_experiencia: "Expérience éducative et illustrative",
consejo_ambiental: "Conseil environnemental : maintenir une bonne flottabilité et des mouvements conscients protège le récif et la vie marine.",
modalTitle: "Résumé du système",
closeModalBtn: "Fermer",
actualiza_indicadores: "Le simulateur met à jour les indicateurs de sécurité et de physiologie pendant la plongée virtuelle et génère un rapport de sortie à des fins d’apprentissage.",
fisiologia: "Physiologie (tissus)",
compartimentos_2: "16 compartiments simulés, charge d’azote et estimation du plafond/remontée.",
ndl_nitros: "NDL et Nitrox",
ndl_recreativo: "NDL récréatif, prise en charge de FO₂ avec profondeur équivalente (EAD) à des fins éducatives.",
consumo_aire_2: "Consommation d’air",
consumo_basado_sac: "Consommation basée sur le SAC, la pression ambiante et le temps simulé ; alertes de réserve et de manque d’air.",
oxigeno_cns: "Oxygène (PPO₂ / CNS)",
calculo_ppo2: "Calcule la PPO₂ en fonction de la profondeur et de FO₂ ; accumule l’exposition CNS et affiche des alertes.",
fines_educativos: "Remarque : toutes les valeurs et visualisations sont à des fins éducatives et de simulation.",
closeSlideBtn: "❌",

safety_stop_menu: "Palier de sécurité",
nitrogen_bar_menu: "Barre N₂",
consumo_aire_menu: "Consommation de gaz",
oxicidad_oxigeno_menu: "Toxicité O₂",
deco_menu: "DECO",
deco_y_paradas_deco: "DECO et ses paliers de décompression",

registro_existoso: "Inscription réussie !",
instrucciones_email_registro: "Votre compte a été créé avec succès. Veuillez valider votre compte dans votre e-mail para vous connecter ! Merci",
cintinuar: "Continuer",



},


payment_stripe:{

  title:"Paiement sécurisé avec Stripe",
  ammount_txt:"Total à payer :<br>",
  currency:"Euros",
  pagar_ahora:"Payer maintenant",
  continuar:"Continuer",
  cancelar:"Annuler",
  error: "Erreur",
  completa_inputs:"Veuillez remplir tous les champs",
  close:"Fermer",
  error_passwords:"Erreur de mot de passe",
  passwords_no_iguales:"Les mots de passe ne correspondent pas",
  error_email: "Erreur d'email",
  ingresa_email_valido:"Veuillez entrer une adresse email valide.",
  user_data:"Informations utilisateur",
  create_account:"Créer un nouveau compte",
  pago_exitoso:"Paiement réussi",
  pago_compeltado:"Votre paiement a été effectué avec succès",
  pago_proceso:"Paiement en cours de traitement",
  confirmaremos_pago:"Nous confirmerons votre paiement sous peu",
  pago_fallido:"Paiement échoué",
  fallo_autenticacion_declinado:"Échec de l'authentification ou paiement refusé",
  status_pago:"Statut du paiement",
  cuenta_existente:"Ce compte existe déjà",
  cuenta_existente_txt:"Cette adresse email a déjà été enregistrée"

},




login:{

  iniciar_session: "Se connecter",
  accede_a_cuenta:"Accédez à votre compte",
  email:"Email",
  password:"Mot de passe",
  iniciar_session_btn:"Se connecter maintenant",
  verificando:"Vérification.....",
  credenciales_incorrectas:"Identifiants incorrects"

},


stripe_user_data:{
  user_data:"Données utilisateur",
  create_account:"Créer un nouveau compte",
  username:"Nom d'utilisateur",
  enter_username:"Entrez le nom complet",
  email_user:"Email utilisateur",
  enter_email:"Entrez un email",
  password:"Mot de passe",
  enter_password:"Entrez un mot de passe",
  repeat_password:"Répéter le mot de passe",
  enter_repeat_password:"Entrez le même mot de passe",
  seleccion_suscripcion:"Sélectionnez le type d’abonnement",
  mensual:"Mensuel",
  semestral:"Semestriel",
  anual:"Annuel"
},


cookies:{
  title:"Cookies Requises",
  message:"Ce site nécessite des cookies pour fonctionner correctement. Vous devez accepter leur utilisation pour continuer.",
  reject:"Refuser",
  accept:"Accepter",
  acceso_denegado:"Accès refusé",
  debes_aceptar:"L’autorisation des cookies est requise pour continuer"
},

condiciones:{

  full:  ` 


<div id="legal_conditions" class="legal_conditions">

<div class="legal_header">
<h1>Conditions Générales d’Utilisation</h1>
</div>


<div id="legal_scroll_container" class="legal_scroll_container">


<div class="section_legal">

<h2>1. IDENTIFICATION DU RESPONSABLE</h2>

<p>
Conformément à la Loi 34/2002 relative aux Services de la Société de l’Information (LSSI-CE),
il est indiqué que ce site web appartient à :
</p>

<ul>
<li><strong>DIVANTIS</strong></li>
<li><strong>Email de contact :</strong> admin@divantys.com</li>
<li><strong>Adresse fiscale :</strong> Málaga, Espagne</li>
<li><strong>Activité :</strong> prestation de services numériques à distance</li>
</ul>

</div>


<div class="section_legal">

<h2>2. OBJET ET CONDITIONS D’UTILISATION</h2>

<p>
Ce site web propose des services numériques,
des contenus interactifs et des outils en ligne.
L’accès au site implique l’acceptation
des présentes conditions.
</p>

<p>L’utilisateur s’engage à :</p>

<ul>
<li>Ne pas réaliser d’activités illégales</li>
<li>Ne pas introduire de code malveillant</li>
<li>Ne pas tenter d’accéder à des systèmes restreints</li>
<li>Ne pas utiliser le site à des fins frauduleuses</li>
</ul>

</div>


<div class="section_legal">

<h2>3. PROPRIÉTÉ INTELLECTUELLE</h2>

<p>
Tous les contenus du site (textes, code, design,
logiciels et images) sont la propriété du titulaire
ou utilisés sous licence.
Toute reproduction, distribution ou modification
sans autorisation expresse est interdite.
</p>

</div>


<div class="section_legal">

<h2>4. DISPONIBILITÉ DU SERVICE</h2>

<p>
Le titulaire peut modifier, suspendre
ou interrompre tout service ou fonctionnalité
du site à tout moment sans préavis.
</p>

</div>


<div class="section_legal">

<h2>5. LIMITATION DE RESPONSABILITÉ</h2>

<p>
Le site est fourni « tel quel ».
Le titulaire ne garantit pas la disponibilité
continue ni l’absence d’erreurs techniques.
</p>

<p>
Le titulaire ne pourra être tenu responsable
des dommages résultant de l’utilisation
ou de l’impossibilité d’utiliser les services proposés.
</p>

</div>


<div class="section_legal">

<h2>6. POLITIQUE DE CONFIDENTIALITÉ (RGPD)</h2>

<h3>Données collectées</h3>

<ul>
<li>Nom</li>
<li>Adresse email</li>
<li>Données envoyées via les formulaires</li>
<li>Données techniques de navigation</li>
</ul>

<h3>Finalité</h3>

<ul>
<li>Répondre aux demandes</li>
<li>Envoyer les informations demandées</li>
<li>Améliorer le service</li>
<li>Communications commerciales (avec consentement)</li>
</ul>

</div>


<div class="section_legal">

<h2>7. CONSERVATION DES DONNÉES</h2>

<p>
Les données personnelles seront conservées
uniquement pendant le temps nécessaire
pour atteindre les objectifs décrits dans cette politique
ou pour respecter les obligations légales.
</p>

</div>


<div class="section_legal">

<h2>8. SERVICES TIERS</h2>

<p>
Ce site peut utiliser des services tiers
tels que des processeurs de paiement,
des fournisseurs d’hébergement
ou des outils d’analyse.
</p>

<p>
Ces fournisseurs peuvent traiter certaines données
techniques ou personnelles
selon leurs propres politiques de confidentialité.
</p>

</div>


<div class="section_legal">

<h2>9. TRANSFERTS INTERNATIONAUX DE DONNÉES</h2>

<p>
Si des fournisseurs technologiques situés
en dehors de l’Espace Économique Européen sont utilisés,
les clauses contractuelles standard approuvées
par la Commission Européenne seront appliquées.
</p>

</div>


<div class="section_legal">

<h2>10. POLITIQUE DE COOKIES</h2>

<p>
Le site peut utiliser des cookies techniques
et analytiques afin d’améliorer l’expérience
et les fonctionnalités du site.
</p>

</div>


<div class="section_legal">

<h2>11. MODIFICATIONS</h2>

<p>
Le titulaire peut modifier ces politiques
à tout moment.
Les modifications entreront en vigueur
à partir de leur publication sur le site.
</p>

</div>


<div class="section_legal">

<h2>12. LÉGISLATION ET JURIDICTION</h2>

<p>
Les présentes conditions sont régies
par la législation espagnole.
Les parties se soumettent aux tribunaux
de Málaga, Espagne.
</p>

</div>


<div class="section_legal">

<h2>13. CONTACT</h2>

<p>
Pour toute question relative
à ces politiques :
</p>

<p>
📧 admin@divantys.com
</p>

</div>


</div>



<div class="legal_controls">

<button id="legal_continue_btn">
Accepter et continuer
</button>

</div>

</div>

    ` 

},


  // ===================================================
  // GENERAL
  // ===================================================
  general: {
    ok: "OK",
    cancel: "Annuler",
    salir: "Quitter",
    button_fisiologia: "Physiologie de la plongée",
    closeReset: "Fermer et réinitialiser",
    startDive: "Démarrer la plongée",
    startNextDive: "Démarrer la plongée suivante",
    firstDive: "Première plongée",
    repetitiveDive: "Plongée successive",
    Dive: "Plongée n°",
    reduce_ascent_speed: "Réduire la vitesse de remontée diminue la surcharge en azote.",
    controlled_ascent_text:
      "N’oubliez pas que vos remontées doivent être lentes et contrôlées afin d’éviter la saturation des tissus. Utilisez la « charge en azote » comme référence."
  },

  // ===================================================
  // ALERTS / MESSAGES
  // ===================================================
  alerts: {
    notice: "Avis",
    invalidSurface: "Intervalle de surface invalide",
    noRepetitive: "Les plongées successives ne sont pas autorisées après cette plongée",
    noTissueData: "Aucune donnée tissulaire disponible",
    recalculating: "Recalcul des compartiments tissulaires…",

    outOfAir: {
      title: "🚨 Plus d’air",
      button: "J’ai compris",
      html: `
        <strong>Situation critique détectée.</strong><br><br>

        • Réserve de gaz épuisée<br>
        • Commencez immédiatement une remontée contrôlée<br>
        • Expiration continue (CESA)<br>
        • Respectez une vitesse de remontée sûre<br><br>

        <em>Cette plongée a été interrompue pour des raisons de sécurité.</em>
      `
    },

    modExceeded: {
      icon: "🫁⚠️",
      color: "#c62828",
      title: "🚨 MOD dépassée pour EAN{{ean}}",
      button: "J’ai compris",
      html: `
        <strong>Vous êtes plus profond que la profondeur opérationnelle sûre pour ce gaz.</strong><br><br>

        <strong>Détails :</strong><br>
        • Profondeur actuelle : <strong>{{depth}} m</strong><br>
        • MOD (PPO₂ 1,4) : <strong>{{mod}} m</strong><br>
        • Action : <strong>remontez</strong> immédiatement vers une profondeur moindre<br><br>

        <em>Cette plongée a été interrompue pour des raisons de sécurité.</em>
      `
    },

    recreationalLimitExceeded: {
      icon: "🚫",
      color: "#c62828",
      title: "🚨 Limites récréatives dépassées",
      button: "J’ai compris",
      html: `
        <strong>Vous avez dépassé les limites standards de la plongée loisir.</strong><br><br>

        <strong>Cela signifie :</strong><br>
        • La limite sans décompression récréative ne s’applique plus<br>
        • Une décompression peut être nécessaire<br>
        • Une formation technique est requise<br>
        • Une planification des gaz et des remontées par paliers peut être nécessaire<br><br>

        <em>Cette plongée a été interrompue pour des raisons de sécurité.</em>
      `
    },

    ndlExceeded: {
      icon: "⏱",
      color: "#c62828",
      title: "🚨 Limite sans décompression dépassée",
      button: "J’ai compris",
      html: `
        <strong>Vous avez dépassé la limite sans décompression.</strong><br><br>

        <strong>Action requise :</strong><br>
        • Remontez immédiatement de manière lente et contrôlée<br>
        • Vitesse maximale de remontée : <strong>9–10 m/min</strong><br>
        • Effectuez un palier de sécurité à <strong>5 m pendant 3–5 minutes</strong><br><br>

        <em>Cette plongée a été interrompue pour des raisons de sécurité.</em>
      `
    },

    safetyStopInterrupted: {
      title: "Palier de sécurité interrompu",
      text: "Redescendez à 5 mètres pour redémarrer le palier de sécurité.",
      color: "warning"
    },

    safetyStopCompleted: {
      title: "Palier de sécurité effectué",
      text: "Vous pouvez poursuivre la remontée en toute sécurité.",
      color: "success"
    },

    low_air_reserve_reached: {
      title: "Air bas — Réserve atteinte",
      text: `
Votre réserve d’air a été atteinte (≈35 bar).

• Commencez une remontée lente et contrôlée
• Ne dépassez pas 9–10 m/min
• Préparez votre palier de sécurité à 5 m
• Restez calme et respirez lentement`,
      color: "warning"
    }
  },

  // ===================================================
  // LOGS / STATES
  // ===================================================
  logs: {
    decoRequired: "🚨 Décompression requise (critère loisir)",
    nearNDL: "⚠️ Proche de la limite sans décompression",
    highTissue: "🟠 Charge tissulaire élevée (modèle physiologique)",
    withinLimits: "✅ Plongée dans les limites récréatives"
  },

  // ===================================================
  // DIVE STATUS
  // ===================================================
  diveStatus: {
    completed: "✅ Plongée terminée",
    failedDeco: "🚨 Plongée échouée — Décompression requise",
    highTissue: "⚠️ Plongée terminée — Charge tissulaire élevée",
    nearNDL: "⚠️ Plongée terminée — Proche de la limite sans décompression",
    dangerous_ascent: "🚨 À un moment donné, vous avez eu une remontée incontrôlée. Soyez prudent",
    fast_ascent: "⚠️ À un moment donné, vous êtes remonté plus rapidement que la vitesse maximale autorisée (9 m/min). Contrôlez toujours votre remontée et anticipez les changements de profondeur"
  },

  // ===================================================
  // SAFETY STOP
  // ===================================================
  safetyStop: {
    title: "Palier de sécurité",
    completed: "✅ <strong>Palier de sécurité effectué</strong>",
    notCompleted: "⚠️ <strong>Palier de sécurité non effectué</strong>",
    timeAt5m: "Temps à 5 m",
    completedAfterInterruptions: "Effectué avec interruptions",
    back_5m: "⬆️ Retour à 5 m",
    hold_5m: "⏸ Maintenez 5 m",
    target_depth: "Profondeur cible : 5 m"
  },

  nitrogen_bar: {
    title: "Charge N₂ (tissus rapides)"
  },

  // ===================================================
  // REPORT / SUMMARY
  // ===================================================
  report: {
    diveNumber: "Plongée",
    time: "Temps",
    maxDepth: "Profondeur max",
    gas: "Gaz",
    tank: "Bloc",
    startPressure: "Pression initiale",
    endPressure: "Pression finale",
    airUsed: "Air consommé",
    sac: "SAC",
    reserveReached: "Réserve atteinte",
    ceiling: "Plafond",
    gf: "GF",
    tissueTitle: "Compartiments tissulaires",
    tissueNote:
      "Les compartiments en rouge indiquent des tissus limitants — pas de décompression obligatoire.",
    ceiling: "Plafond",
    safetystop: "Palier de sécurité"
  },

  camera_hud: {
    t1: "Ajuster le trim neutre",
    level_ok: "✓ Neutre",
    level_hint: "Touchez ⦿ pour le trim neutre"
  },

  // ===================================================
  // PROFILE
  // ===================================================
  profile: {
    title: "Profil de profondeur"
  },

  // ===================================================
  // TISSUES
  // ===================================================
  tissues: {
    title: "Compartiments tissulaires (N₂)",
    surfaceOffGassing: "Désaturation en surface",
    afterInterval: "Après",
    minutes: "min",
    offGas: "⬇ désaturation",
    onGas: "⬆ saturation",
    tissues_data_invalidos: "Aucune information tissulaire disponible"
  },

  // ===================================================
  // SURFACE INTERVAL
  // ===================================================
  surface: {
    title: "Intervalle de surface (min)",
    invalid_interval_surface: "Durée de l’intervalle de surface invalide",
    recalc: "Recalculer les tissus",
    after: "Après",
    notAllowed: "Les plongées successives ne sont pas autorisées après cette plongée"
  },

  // ===================================================
  // REPETITIVE DIVES
  // ===================================================
  repetitive: {
    tag: "Plongée successive",
    info:
      "Cette plongée commence avec de l’azote résiduel provenant d’une plongée précédente. Une remontée conservatrice et un palier de sécurité complet sont recommandés.",
    first_dive: "Première plongée",
    repetitive_dive: "Plongée successive"
  },

  // ===================================================
  // EDUCATION / LEGAL NOTICE
  // ===================================================
  education: {
    longHTML: `
<strong>ℹ️ Pourquoi ce message est-il apparu ?</strong><br><br>

<strong>Durant cette simulation, le profil est resté dans les limites sans décompression affichées.</strong>
À aucun moment la limite dynamique sans décompression (NDL) représentée par le système
n’a atteint zéro, et aucun palier de décompression obligatoire n’a été généré dans l’environnement simulé.
<br><br>

Le message affiché <strong>n’indique ni une erreur, ni une plongée échouée, ni une infraction</strong>.
Il est strictement informatif et découle
<strong>du même modèle physiologique interne</strong> appliqué de manière cohérente tout au long de la simulation.
<br><br>

<strong>Comment fonctionne ce simulateur ?</strong><br>
Ce simulateur est un <strong>outil de visualisation et d’illustration</strong>
destiné à présenter des concepts généraux liés à la physiologie de la plongée.
Il repose sur un <strong>modèle théorique de suivi continu des tissus</strong>,
inspiré de cadres de décompression largement documentés
(comme le Bühlmann ZHL-16C avec logique de facteurs de gradient),
et est utilisé exclusivement à des fins représentatives.
<br><br>

Pendant la plongée simulée, le système :
<ul style="margin:8px 0 0 18px;">
  <li>présente des estimations relatives de l’absorption de gaz inerte dans des compartiments tissulaires théoriques</li>
  <li>montre la proximité de ces compartiments par rapport à des limites modélisées</li>
  <li>illustre la variation de la conservativité de la remontée <em>uniquement dans la simulation</em></li>
</ul>
<br>

<strong>Pourquoi un avis peut-il apparaître même si la NDL a été respectée ?</strong><br>
Même lorsqu’aucune obligation de décompression n’est représentée,
le modèle peut afficher <strong>des charges relativement élevées de gaz inerte</strong>
dans certains tissus simulés.
Cela peut se produire pour des profils comprenant :
<ul style="margin:8px 0 0 18px;">
  <li>des temps prolongés au fond</li>
  <li>des expositions proches de la limite sans décompression</li>
  <li>des profondeurs modérées maintenues sur de longues durées</li>
</ul>
<br>

Dans ces cas, le système peut afficher un
<strong>message informatif préventif</strong>,
dont le seul objectif est de fournir un contexte physiologique supplémentaire dans la visualisation.
Ce message <strong>ne constitue ni une instruction opérationnelle ni un conseil de plongée</strong>.
<br><br>

<strong>🟠 Clarification importante :</strong><br>
Ce message <strong>ne représente pas des exigences de décompression</strong>,
<strong>n’est ni une alarme ni une instruction d’un ordinateur de plongée</strong>,
et <strong>n’implique aucune pratique dangereuse, incorrecte ou non conforme</strong>.
Il reflète uniquement que, dans le cadre du modèle simulé,
certains tissus ont présenté une charge en gaz inerte relativement plus élevée
par rapport à une plongée loisir courte typique.
<br><br>

<strong>En termes simples :</strong><br>
Le profil simulé est resté dans les limites représentées.
Ce message indique simplement :
<em>« Ce scénario simulé s’est approché d’une marge conservatrice, des informations contextuelles supplémentaires sont donc affichées. »</em>
<br><br>

<strong>Avis légal :</strong><br>
Ce simulateur est fourni <strong>exclusivement à des fins de visualisation et d’illustration</strong>.
<strong>Il ne s’agit pas d’un ordinateur de plongée</strong>,
<strong>il ne remplace pas la formation certifiée ni le rôle éducatif des agences reconnues</strong>,
et <strong>ne doit pas être utilisé comme base de prise de décision pour des plongées réelles</strong>.
`
  },

  // ===================================================
  // PRE-DIVE CHECK
  // ===================================================
  predive: {
    title: "Contrôle de sécurité avant la plongée",
    subtitle: "Contrôle de sécurité pré-plongée standard de l’industrie (BWRAF) et sélection du gaz",
    selectGas: "Sélectionner le gaz respirable",
    start: "Démarrer la plongée",
    cancel: "Annuler et réinitialiser",
    descargar: "Télécharger le rapport",
    bwraf: {
      b: "Gilet : gonfler / dégonfler, inflateur fonctionnel",
      w: "Lestage : quantité correcte, largage rapide dégagé",
      r: "Fixations : sangles, boucles et bloc sécurisés",
      a: "Air : robinet ouvert, respirer et vérifier la pression",
      f: "Final : masque, palmes, ordinateur, binôme prêt"
    }
  },

  scale_time_home: {
  title: "Échelle de temps de la simulation",
  text: `
    Ce simulateur peut <strong>accélérer le temps</strong> afin de
    visualiser des processus physiologiques (NDL, charge en azote,
    comportement de remontée) qui, en plongée réelle,
    prennent beaucoup plus de temps.
    <br><br>
    Cela <strong>ne représente pas le temps réel</strong> et est utilisé
    <strong>uniquement à des fins éducatives et de visualisation</strong>.
  `,
  real_time: "Temps réel",
  choose: "Sélectionnez la vitesse de simulation :",
  start: "Commencer l’immersion"
},



comparativa_tablas_tejidos_bhulmann: {
  text: `
    <div style="display:flex; flex-direction:column; gap:14px; line-height:1.65; color:#eaf4ff;">

      <div style="background:rgba(255,255,255,.06); border:1px solid rgba(255,255,255,.08); border-radius:16px; padding:16px;">
        <div style="font-size:18px; font-weight:700; margin-bottom:8px;">
          🧠📊 Tables vs Modèle physiologique
        </div>
        <div style="font-size:14px; opacity:.95;">
          Les deux servent à estimer la limite sans décompression (NDL), mais <strong>ils ne fonctionnent pas de la même manière</strong>.
          C’est pourquoi ils peuvent parfois afficher des résultats différents.
        </div>
      </div>

      <div style="display:grid; gap:12px;">
        
        <div style="background:rgba(0,153,255,.10); border:1px solid rgba(0,153,255,.25); border-radius:16px; padding:16px;">
          <div style="font-size:16px; font-weight:700; margin-bottom:8px;">
            🔵 Tables récréatives (PADI / DSAT)
          </div>
          <div style="font-size:14px;">
            <div>⏱️ Donnent un <strong>temps fixe</strong> en fonction de la profondeur.</div>
            <div>📚 Basées sur des études et des marges de sécurité.</div>
            <div>🧮 <strong>Ne calculent pas</strong> votre corps en temps réel.</div>
            <div>🟢 Simples, rapides et faciles à utiliser.</div>
          </div>

          <div style="margin-top:10px; font-size:14px; background:rgba(255,255,255,.05); border-radius:12px; padding:10px;">
            👉 Exemple : à <strong>20 m</strong>, la table peut indiquer <strong>NDL ≈ 45 min</strong>.
          </div>
        </div>

        <div style="background:rgba(0,255,170,.08); border:1px solid rgba(0,255,170,.22); border-radius:16px; padding:16px;">
          <div style="font-size:16px; font-weight:700; margin-bottom:8px;">
            🟢 Modèle Bühlmann (ce simulateur)
          </div>
          <div style="font-size:14px;">
            <div>🧠 Simule <strong>16 tissus virtuels</strong> du corps.</div>
            <div>📈 Calcule en temps réel l’absorption et l’élimination de l’azote.</div>
            <div>⚙️ S’adapte à votre profil réel : <strong>profondeur, temps et gaz</strong>.</div>
            <div>🎯 Plus dynamique et plus réaliste.</div>
          </div>

          <div style="margin-top:10px; font-size:14px; background:rgba(255,255,255,.05); border-radius:12px; padding:10px;">
            👉 Ici, le <strong>NDL n’est pas fixe</strong> : il correspond au moment où une <strong>pause de décompression devient nécessaire</strong>.
          </div>
        </div>

      </div>

      <div style="background:rgba(255,196,0,.10); border:1px solid rgba(255,196,0,.25); border-radius:16px; padding:16px;">
        <div style="font-size:16px; font-weight:700; margin-bottom:8px;">
          ⚠️ Pourquoi ne correspondent-ils pas toujours ?
        </div>
        <div style="font-size:14px;">
          <div>📚 Les tables récréatives sont plus <strong>conservatrices</strong>.</div>
          <div>🧠 Le modèle Bühlmann calcule en continu ce qui se passe réellement dans votre corps.</div>
          <div>🔍 C’est pourquoi le simulateur peut afficher un NDL différent des tables classiques.</div>
        </div>
      </div>

      <div style="background:rgba(255,255,255,.06); border:1px solid rgba(255,255,255,.08); border-radius:16px; padding:16px;">
        <div style="font-size:16px; font-weight:700; margin-bottom:8px;">
          💡 Résumé
        </div>
        <div style="font-size:14px;">
          <div>🔵 <strong>Tables</strong> = approximation simple et conservatrice</div>
          <div>🟢 <strong>Bühlmann</strong> = simulation physiologique plus réaliste</div>
        </div>

        <div style="margin-top:10px; font-size:14px; font-weight:600;">
          👉 Ce simulateur utilise le modèle Bühlmann pour fournir une estimation plus dynamique du NDL.
        </div>
      </div>

    </div>
  `
},


block_student: {
    riesgo_accidente_disbarico: "Risque élevé d'accident de décompression",
    riesgo_microburbujas: "Risque de microbulles",
    reducir_velocidad: "Vous devez réduire la vitesse de remontée à 9m/min",
    ascenso_ideal: "Vitesse de remontée idéale",
    ascenso_lento: "Remontée lente. Correct",
    ascent_rate: "Vitesse de remontée"
},


dashboard:{
     profile_txt: "Mon profil",
    logout_txt:"Se déconnecter",
    welcome_label:"Bienvenue",
    payments_title:"Tableau des paiements",
    startSimulatorBtn:"🎮 Démarrer le simulateur de plongée",
    view_payments:"Voir les paiements",
    view_simulator_logs:"Logs du simulateur",
    paymentsEmpty:"Chargement des paiements...",
    response_title:"Paiements",
    activo_con_previa_cancelacion: "🎮 Accès actif (annulation programmée)",
    fecha_cancelacion_suscripcion: "⚠️ Votre abonnement sera annulé le :",
    en_proceso_cancelacion: "🟠 Abonnement en cours d’annulation",
    acceso_hasta: "Accès disponible jusqu’au :",
    despues_esta_fecha_no_acceso: "Après cette date, l’accès sera automatiquement supprimé",
    suscripcion_finalizada: "💳 Abonnement terminé",
    suscripcion_cancelada: "🔴 Abonnement annulé",
    acceso_habiliatdo: "🟢 Accès activé :",
    upgrade_plan : "Modifier mon plan",
    modificar_a :"Modifier en :",
    tienes_el_plan_maximo: "✨ Vous avez le plan maximum disponible.",
    reactivar_suscripcion: "🔄 Réactiver l’abonnement",
    cancelar_suscripcion: "❌ Annuler l’abonnement",
    en_proceso: "⏳ Traitement...",
    cancelando: "⏳ Annulation...",
    cancelada: "✅ Annulée",
    error: "❌ Erreur",
    reactivando_suscripcion: "⏳ Réactivation...",
    reactivada: "✅ Réactivée",
    no_pagos_aun: "Aucun paiement enregistré pour le moment.",
    pagar: "💳 Payer",
    pagado: "💳 Crédité",
    activar_acceso_simulador: "💳 Activer l'accès au simulateur",
    sin_suscripcion_inactiva: "🔴 Aucune souscription active",
    membresia_title: "Abonnement",
credits_title: "Crédits",
add_saldo: "Ajouter des crédits",
}




}
